
import { Validator } from "@angular/forms/src/directives/validators";
import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS } from "@angular/forms";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[ConsentValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: ConsentValidator,
    multi: true
  }]
})


export class ConsentValidator implements Validator {
  @Input() forbiddenDateValidator: string;
  validate(control: AbstractControl): { [key: string]: any } | null {
    if (control.value != false) {
      return null;
    }
      return { 'notValidConsent': true };
    }
  }

